module.exports = __webpack_public_path__ + "static/media/sean-languedoc.2b52088e.jpeg";